export const GET_HOME_DATA = 'GET_HOME_DATA';
export const GET_HOME_LOADING = 'GET_HOME_LOADING';
export const GET_LANDING_PAGE_DATA = 'GET_LANDING_PAGE_DATA';
export const GET_LANDING_PAGE_LOADING = 'GET_LANDING_PAGE_LOADING';
